import { Multiname } from '../abc/lazy/Multiname';
export var rn = new Multiname(null, 0, 17 /* CONSTANT.RTQNameL */, [], null, null, true);
